import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData({
        title: '文华TMS交易管理系统'
    }).then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0

        //网站title定制
        if(!document.title){
            let obj = {};
            res.forEach(item => {
                obj[item.keyname] = item.value;
            });
            document.title = '文华' + obj['appFullName_TMS'];
        }
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()